import styles from './SavedSearchesDashboard.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { HeartIcon, ChevronIcon } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';
import QualifiedLink from 'QualifiedLink/QualifiedLink';
import DashboardItem from 'DashboardItem/DashboardItem';
import DashboardHeading from 'DashboardHeading/DashboardHeading';
import { ScreenReaderOnly } from 'seek-style-guide/react';

import { savedSearchClicked } from 'store/dashboard/dashboard';

const mapStateToProps = ({ dashboard }) => ({
  savedSearches: dashboard.savedSearches.data,
  totalCount: dashboard.savedSearches.totalCount
});

const mapDispatchToProps = dispatch => ({
  searchClicked: index => dispatch(savedSearchClicked(index))
});

@connect(mapStateToProps, mapDispatchToProps)
export default class SavedSearchesDashboard extends Component {

  static propTypes = {
    savedSearches: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        count: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        summary: PropTypes.string.isRequired,
        query: PropTypes.object.isRequired
      })
    ),
    totalCount: PropTypes.number,
    searchClicked: PropTypes.func.isRequired
  };

  static defaultProps = {
    savedSearches: [],
    totalCount: 0
  };

  renderLink({ name, query, count }, index, searchClicked) {
    /* eslint-disable react/jsx-no-bind */
    return (
      <QualifiedLink
        className={styles.headingLink}
        analytics="dashboard-save-search-click"
        path="/jobs"
        params={query}
        onClick={() => searchClicked(index)}>
        <ScreenReaderOnly>
          {`${count} new ${count === 1 ? 'job' : 'jobs'} for:`}
        </ScreenReaderOnly>
        {name}
      </QualifiedLink>
    );
    /* eslint-enable react/jsx-no-bind */
  }

  render() {
    const { savedSearches, totalCount, searchClicked } = this.props;
    const label = `Saved ${totalCount === 1 ? 'search' : 'searches'}`;

    return (
      <nav role="navigation" data-automation="savedSearchDashboard">
        <DashboardHeading
          label={label}
          count={totalCount}
          Icon={HeartIcon}
          iconClass={styles.icon}
          className={styles.heading}
          href="/myactivity#favourite"
          analytics="dashboard-heading-saved-searches-click"
        />
        {
          savedSearches.length > 0 &&
            <div className={styles.items}>
              {
                savedSearches.map((savedSearch, index) => {
                  const { id, count, summary } = savedSearch;

                  /* eslint-disable react/jsx-no-bind */
                  return (
                    <DashboardItem
                      key={id}
                      heading={() => this.renderLink(savedSearch, index, searchClicked)}
                      subheading={() => <span aria-hidden="true">{summary}</span>}
                      count={() => <span aria-hidden="true">{`${count} new`}</span>}
                    />
                  );
                  /* eslint-enable react/jsx-no-bind */
                })
              }
            </div>
        }
        {
          savedSearches.length > 0 &&
            <ExternalLink
              className={styles.viewAll}
              analytics="dashboard-all-saved-searches-click"
              href="/myactivity#favourite">
              View all<ScreenReaderOnly>your saved searches</ScreenReaderOnly>
              <ChevronIcon
                className={styles.chevron}
                direction="right"
                svgClassName={styles.chevronSvg}
              />
            </ExternalLink>
        }
        {
          savedSearches.length === 0 &&
            <p className={styles.noItems}>
              {'Use the '}
              <span className={styles.noItems_highlight}>
                <HeartIcon svgClassName={styles.iconSvg} />
                {' Save search '}
              </span>
              button below the search results to save your search and receive every new job.
            </p>
        }
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/SavedSearchesDashboard/SavedSearchesDashboard.js
 **/